export function isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    const isApple = navigator.vendor.includes('Apple');
    const isSafari = ua.includes('safari') && !ua.includes('chrome');
    return isApple && (isSafari || ua.includes('mac os'));
}

export const IS_SAFARI = isSafari();

export const IS_IOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);
